import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Contact } from '../models/ContactForm.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private apiUrl = environment.apis.dataSentinel;
  private readonly REQUEST_ORIGIN = "WEB";

  constructor(private _http: HttpClient) { }

  postContact(idOrganizacion: string, idUsuario: string, contactFormData: Contact) {
    let headers = new HttpHeaders()

    const body = {
      requestOrigin: this.REQUEST_ORIGIN,
      idOrganizacion,
      idUsuario,
      ...contactFormData,
    }

    return this._http.post<any>(this.apiUrl + '/correoSoporte', body, {headers, responseType: 'json'});
  }

}
